/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateDiscreteNumericListDtoGeometry } from './CreateDiscreteNumericListDtoGeometry';
import {
    CreateDiscreteNumericListDtoGeometryFromJSON,
    CreateDiscreteNumericListDtoGeometryFromJSONTyped,
    CreateDiscreteNumericListDtoGeometryToJSON,
} from './CreateDiscreteNumericListDtoGeometry';

/**
 * 
 * @export
 * @interface CreateDiscreteNumericValueDto
 */
export interface CreateDiscreteNumericValueDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDiscreteNumericValueDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiscreteNumericValueDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDiscreteNumericValueDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDiscreteNumericValueDto
     */
    isReadonly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDiscreteNumericValueDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateDiscreteNumericValueDto
     */
    numericId?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateDiscreteNumericValueDto
     */
    value?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateDiscreteNumericValueDto
     */
    availableValues?: Array<number> | null;
    /**
     * 
     * @type {CreateDiscreteNumericListDtoGeometry}
     * @memberof CreateDiscreteNumericValueDto
     */
    geometry?: CreateDiscreteNumericListDtoGeometry | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDiscreteNumericValueDto
     */
    $type?: CreateDiscreteNumericValueDtoTypeEnum;
}


/**
 * @export
 */
export const CreateDiscreteNumericValueDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoCreateDiscreteNumericValueDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.CreateDiscreteNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateDiscreteNumericValueDtoTypeEnum = typeof CreateDiscreteNumericValueDtoTypeEnum[keyof typeof CreateDiscreteNumericValueDtoTypeEnum];


/**
 * Check if a given object implements the CreateDiscreteNumericValueDto interface.
 */
export function instanceOfCreateDiscreteNumericValueDto(value?: unknown): value is CreateDiscreteNumericValueDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateDiscreteNumericValueDtoTypeEnum)[0];
}

export function CreateDiscreteNumericValueDtoFromJSON(json: any): CreateDiscreteNumericValueDto {
    return CreateDiscreteNumericValueDtoFromJSONTyped(json, false);
}

export function CreateDiscreteNumericValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDiscreteNumericValueDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataTypeId': !exists(json, 'dataTypeId') ? undefined : json['dataTypeId'],
        'isRequired': !exists(json, 'isRequired') ? undefined : json['isRequired'],
        'isReadonly': !exists(json, 'isReadonly') ? undefined : json['isReadonly'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        'numericId': !exists(json, 'numericId') ? undefined : json['numericId'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'availableValues': !exists(json, 'availableValues') ? undefined : json['availableValues'],
        'geometry': !exists(json, 'geometry') ? undefined : CreateDiscreteNumericListDtoGeometryFromJSON(json['geometry']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateDiscreteNumericValueDtoToJSON(value?: CreateDiscreteNumericValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'dataTypeId': value.dataTypeId,
        'isRequired': value.isRequired,
        'isReadonly': value.isReadonly,
        'isEnabled': value.isEnabled,
        'numericId': value.numericId,
        'value': value.value,
        'availableValues': value.availableValues,
        'geometry': CreateDiscreteNumericListDtoGeometryToJSON(value.geometry),
        '$type': value.$type,
    });
}

